// 확장 설치·교체 안내의 화면 글 한 곳(사장님 10-21 «설치 뒤 쿠플러스 화면 새로고침(F5)») — 단계 원본 = knowledge/확정/couplus-extension-설치와-시작.md §4.
// 새로고침 전 쿠플러스 화면은 새 확장과 안 이어져 «안 된다» 로 보인다. 끝 단계를 빼지 않는다(cs-tools/__tests__/ext-install-steps.js).
export const EXT_REFRESH_STEP = '확장을 설치·업데이트했으면 열어 둔 쿠플러스 화면을 새로고침(F5)';

// 확장이 답하지 않을 때(AIRocketReg 카테고리 읽기·목록)
export const EXT_NO_ANSWER = `쿠플러스 확장 프로그램이 응답하지 않습니다. 확장 프로그램을 설치했는지, 최신 버전으로 갱신했는지 확인하고, ${EXT_REFRESH_STEP}한 뒤 다시 시도해주세요.`;

// 키워드·카테고리 분석 화면 5곳의 «수집이 잘 되지 않는 경우 조치방법»(번호는 화면이 붙인다)
export const EXT_COLLECT_TIPS = [
  `${EXT_REFRESH_STEP} — 그래도 안 되면 쿠플러스 사이트를 닫았다가 열어서 다시 로그인 후에 키워드 분석 시도하기`,
  '크롬 브라우저 사용하기',
  '확장앱 중 1688/타오바오/알리바바 이미지서치 앱 삭제',
  '크롬 브라우저의 계정을 별도의 계정으로 추가해서 쿠플러스만 확장 설치 후 실행하기',
];

// 윙 광고 키워드 화면 2곳(Ad/adkeyword · Analysis/keywordOptimize)의 «수집이 잘 되지 않는 경우 조치방법» — 윙 세션을 쓰는 화면이라 윙 로그인 줄
export const EXT_COLLECT_TIPS_WING = [
  `${EXT_REFRESH_STEP} — 그래도 안 되면 모든 크롬 탭을 닫고 새탭을 열어 쿠팡윙에 로그인하고 새탭을 열어 쿠플러스에 다시 로그인 후에 다시 시도하기`,
  'http://www.couplus.co.kr 링크로 다시 접속해서 시도하기',
  '크롬 브라우저 사용하기',
  '확장앱 중 1688/타오바오/알리바바 이미지서치 앱 삭제',
  '크롬 브라우저 삭제 후 재설치',
];
